import React, { useEffect, useState } from 'react';
import { ThemeProvider, createTheme } from '@material-ui/core/styles';
import { BrowserRouter } from 'react-router-dom';
import dayjs from 'dayjs';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import 'react-day-picker/lib/style.css';
import '../static/css/base.css';
import '../static/css/fontello.css';
import '../static/css/gothamSSm.css';
import PropTypes from 'prop-types';
import {
  MsalProvider,
} from '@azure/msal-react';
import FingerprintJS from '@fingerprintjs/fingerprintjs';
import { RecoilRoot } from 'recoil';
import LocaleRoutes from './LocaleRoutes';
import AppContext from '../state/AppContext';
import themeMUI from '../helpers/themeMUI';

const theme = createTheme(themeMUI);

const Root = ({ msalInstance }) => {
  dayjs.extend(localizedFormat);
  dayjs.extend(isSameOrAfter);
  dayjs.extend(isSameOrBefore);

  // NOTHING MORE SHOULD BE ADDED HERE, WE ARE TRANSITIONING TO RECOIL
  const [appointmentDeletionFailed, setAppointmentDeletionFailed] = useState(false);
  const [appointmentToModify, setAppointmentToModify] = useState(null);
  const [browserFingerprint, setBrowserFingerprint] = useState(null);
  const [customerNeedsSignup, setCustomerNeedsSignup] = useState(null);
  const [customerNotValid, setCustomerNotValid] = useState(false);
  const [filteredMarkers, setFilteredMarkers] = useState([]);
  const [isAppointmentConfirmed, setIsAppointmentConfirmed] = useState(false);
  const [isFirstAppointment, setIsFirstAppointment] = useState(null);
  const [isFollowUp, setIsFollowUp] = useState(false);
  const [isUserSubmittingAddress, setIsUserSubmittingAddress] = useState(false);
  const [mapAddress, setMapAddress] = useState('');
  const [mapBounds, setMapBounds] = useState(null);
  const [markers, setMarkers] = useState(null);
  const [schedulerTherapists, setSchedulerTherapists] = useState([]);
  const [userLocationMarker, setUserLocationMarker] = useState(null);
  // NOTHING MORE SHOULD BE ADDED HERE, WE ARE TRANSITIONING TO RECOIL

  const value = {
    isFollowUp,
    setIsFollowUp,
    appointmentToModify,
    isFirstAppointment,
    schedulerTherapists,
    setSchedulerTherapists,
    browserFingerprint,
    isAppointmentConfirmed,
    customerNeedsSignup,
    customerNotValid,
    filteredMarkers,
    appointmentDeletionFailed,
    isUserSubmittingAddress,
    mapAddress,
    mapBounds,
    markers,
    setAppointmentToModify,
    setIsFirstAppointment,
    setBrowserFingerprint,
    setIsAppointmentConfirmed,
    setCustomerNeedsSignup,
    setCustomerNotValid,
    setFilteredMarkers,
    setAppointmentDeletionFailed,
    setIsUserSubmittingAddress,
    setMapAddress,
    setMapBounds,
    setMarkers,
    setUserLocationMarker,
    userLocationMarker,
  };

  useEffect(() => {
    // Initialize an agent at application startup.
    const fpPromise = FingerprintJS.load();

    (async () => {
      // Get the visitor identifier when you need it.
      const fp = await fpPromise;
      const result = await fp.get();
      setBrowserFingerprint(result.visitorId);
    })();
  }, []);

  return (
    <RecoilRoot>
      <MsalProvider instance={msalInstance}>
        <ThemeProvider theme={theme}>
          <AppContext.Provider value={value}>
            <BrowserRouter>
              <LocaleRoutes />
            </BrowserRouter>
          </AppContext.Provider>
        </ThemeProvider>
      </MsalProvider>
    </RecoilRoot>
  );
};

Root.propTypes = {
  msalInstance: PropTypes.shape({}).isRequired,
};

export default Root;
